export const getDownload = (constent: string, filename?: string) => {
  const encodedUri = encodeURI(constent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename || 'download');
  document.body.appendChild(link);
  link.click();
  link.remove();
};
